import Component from '@glimmer/component';
import { service } from '@ember/service';
import NewOrder from 'bcl/components/modal/new-order';
import Stocktaking from 'bcl/components/modal/stocktaking';
import type ModalService from 'bcl/services/modal';

export default class AuthRoute extends Component {
  @service declare modal: ModalService;
  <template>
    <NewOrder
      @shown={{this.modal.isShownNewOrder}}
      @toggle={{this.modal.toggleNewOrder}}
    />
    <Stocktaking
      @shown={{this.modal.isShownStocktaking}}
      @toggle={{this.modal.toggleStocktaking}}
    />

    {{outlet}}
  </template>
}
